<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <!-- <TheSidebar /> -->
    <NewSideBar />
    <!-- <TheAside /> -->
    <!-- {{role_aktif}} -->
    <SidebarRight v-if="role_aktif.levelRole >= 50" />
    <CWrapper>
      <TheHeader />
      <div class="c-body">
        <main class="c-main m-3 p-0">
          <CContainer fluid class="m-0 p-0">
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <!-- <TheFooter/> -->
    </CWrapper>
  </div>
</template>

<script>
// import TheSidebar from "./TheSidebar";
import NewSideBar from "./TeSideBar.vue"
import TheHeader from "./TheHeader";
// import TheFooter from './TheFooter'
// import TheAside from "./TheAside";
import SidebarRight from "./SidebarRight.vue";

export default {
  name: "TheContainer",
  components: {
    // TheSidebar,
    TheHeader,
    // TheFooter,
    // TheAside,
    SidebarRight,
    NewSideBar
    // TheFooter,
    // TheAside
  },
  computed: {
    role_aktif() {
      return this.$store.state.role_aktif ? this.$store.state.role_aktif : {};
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
